function registerEventHandlerShim(component, key) {
  component[key] = event => {
    const { props } = component
    if (typeof props[key] === 'function') {
      let options = props
      if (event) {
        event.preventDefault()
        event.stopPropagation()
        options = Object.assign({ event }, props)
      }
      props[key](options)
    }
  }
}

function registerComponentEventHandlers(componentInstance) {
  const { constructor } = componentInstance
  const { eventHandlerKeys } = constructor
  if (!eventHandlerKeys) {
    throw new Error(`Component[${constructor.name}] is missing eventHandlerKeys`)
  }
  eventHandlerKeys.forEach(key => {
    registerEventHandlerShim(componentInstance, key)
  })
}

module.exports = {
  registerEventHandlerShim,
  registerComponentEventHandlers
}
